export enum BlogStep {
  'NuevaInversa' = 0,
  Buscar = 1,
  Seleccionar = 2,
  SeleccionDevolucion = 3,
  SeleccionLoteCreacionAsn = 4,
  Calidad = 5
}
